// extracted by mini-css-extract-plugin
module.exports = {"toast":"Toast_toast__TANW5","width-grow-f":"Toast_width-grow-f__lQ1bq"};